/**
 * Formatting helpers with no domain in them.
 *
 * Distinct from services/hiveActions.js, which also exports formatters
 * (formatDateOnly, hiveLabel) but is a beekeeping module -- hiveLabel
 * knows that hive_number restarts per site. Nothing here knows anything
 * about bees, which is why it sits beside utils/csv.js instead.
 */

/**
 * A currency amount.
 *
 * THE FOUR COPIES THIS REPLACES WERE NOT ALL THE SAME, which is the
 * reason this is worth a comment. Three of them were
 *
 *     `$${Number(n || 0).toFixed(2)}`
 *
 * and the fourth, in VendorLedger, put the sign BEFORE the currency
 * symbol using a real minus sign (U+2212):
 *
 *     -$5.00      not      $-5.00
 *
 * That version is right and the other three were wrong, so this
 * reconciles rather than flattening: the ledger's behaviour becomes
 * everyone's. `$-5.00` is not how money is written anywhere, and it
 * turns up wherever a balance can go negative -- an overpaid vendor, a
 * refunded sale, an outstanding figure after a credit. The three callers
 * that had the simpler version were not choosing to render negatives
 * badly; they had not met one yet.
 *
 * U+2212 rather than a hyphen for the same reason: it is the character
 * that means "minus", it is the width of a digit so a column of figures
 * stays aligned, and a hyphen next to a currency symbol reads as a dash.
 *
 * Number(n || 0) keeps the original tolerance for null, undefined and ""
 * -- a missing figure renders as $0.00 rather than $NaN. Note this also
 * makes a genuine 0 and a missing value look identical, which was true
 * of all four originals and is not something this change should decide
 * on quietly.
 */
export function money(n) {
  const value = Number(n || 0);
  const text = `$${Math.abs(value).toFixed(2)}`;
  return value < 0 ? `−${text}` : text;
}
